import { useMemo } from 'react';
// Types
import { CampaignType } from 'api/graphql-global-types';
// Helpers
import {
  CUSTOM_CAMPAIGN_MODE_CONFIG,
  CustomCampaignEditMode,
  CustomCampaignModeConfig,
  resolveCustomCampaignEditMode,
} from 'helpers/customCampaignModeConfig';

type UseCustomCampaignModeResult = {
  mode: CustomCampaignEditMode;
  config: CustomCampaignModeConfig;
};

/**
 * Resolves edit-mode config for Custom / Direct Booking campaigns.
 * Mirrors millions-fe CampaignModeContext, but BO passes campaign type
 * explicitly instead of reading route query params.
 */
export const useCustomCampaignMode = (
  campaignType: CampaignType
): UseCustomCampaignModeResult => {
  return useMemo(() => {
    const mode = resolveCustomCampaignEditMode(campaignType);
    return {
      mode,
      config: CUSTOM_CAMPAIGN_MODE_CONFIG[mode],
    };
  }, [campaignType]);
};
